module.exports = __webpack_public_path__ + "img/items-grid-05.3345bd39.png";